import { renderCart } from '@shopline/sl-checkout-module/cart';
import { attempt, isError } from 'lodash-es';
import currencyService from '../../service/currencyService';
import { CART_REVAMP_TRACKER_TYPE } from '../../shop/constants/tracker';
import parseEscapeData from '../../utils/parseEscapeData';
import cartPageEvent from './events/cart';
import initCartPageEvent from './events/initCartPageEvent';
import prepareMainConfig from './utils/prepareMainConfig';

import '@shopline/sl-checkout-module/cart.css';

function mountCart() {
  const cartApp = document.getElementById('cart-app-root');

  if (!cartApp) return;

  function getCartData() {
    const initCartData = {
      cart: {},
      cartAddonPromotion: undefined,
      extraMainConfig: {},
    };

    const rawCartData =
      document.getElementById('sl-cart-init-data')?.textContent;
    const cartData = attempt(parseEscapeData, rawCartData);

    if (isError(cartData)) {
      console.error('Failed to get cart data', cartData);
      return initCartData;
    }

    return cartData;
  }

  const { cart, cartAddonPromotion, extraMainConfig } = getCartData();

  cartPageEvent.onTrackEvent(CART_REVAMP_TRACKER_TYPE.CartPageLoad, {
    cartItems: cart.items,
    cartSubtotal: cart.subtotal,
  });

  const { pageEvent } = renderCart(cartApp, {
    mainConfig: prepareMainConfig(window.mainConfig, extraMainConfig),
    cart,
    cartAddonPromotion,
    currencyService,
    csrfToken: document
      .querySelector('meta[name=csrf-token]')
      ?.getAttribute('content'),
    outerEvent: cartPageEvent,
  });

  initCartPageEvent(pageEvent);
}

mountCart();
